// extracted by mini-css-extract-plugin
export default {"content":"styles-module--content--2CoLu","header":"styles-module--header--2hnRD","open":"styles-module--open--2EP4l"};